<template>
  <div>
    <header class="headerCom">
      <div class="text"><span>运营管理 / </span><span>关注回复配置</span></div>
      <el-form :inline="true" size="small">
        <el-form-item v-if="current == 0 || current == 2">
          <el-select class="search-input-replay" maxlength="20" v-model="listQuery.hospitalId" placeholder="请输入机构名称进行搜索"
            filterable remote reserve-keyword v-selectLoadmore="loadmoreHospital" :remote-method="remoteHospital"
            :loading="codeLoading" @change='onChangeHospital' @visible-change='closeHospital' clearable>
            <el-option v-for="(item,index) in hospitalList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <template v-if="current == 1">
          <el-form-item>
            <el-select class="search-input-replay" maxlength="20" v-model="listQuery.diseaseTypeId"
              placeholder="请输入病种进行搜索" clearable filterable remote reserve-keyword v-selectLoadmore="loadmoreDiseaseType"
              :remote-method="remoteDiseaseType" :loading="codeLoading" @visible-change='closeDisease'
              @change='onChangeDisease'>
              <el-option v-for="(item,index) in diseaseTypeList" :key="index" :label="item.entryName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input class="search-input-replay" maxlength="20" v-model="listQuery.keyword"
              placeholder="请输入疗管团队名称或医生姓名进行搜索" clearable autocomplete="off">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </template>
        <template v-if="current == 2">
          <el-form-item>
            <el-input class="search-input-replay" maxlength="20" v-model="listQuery.userName" clearable
              placeholder="请输入用户姓进行搜索">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </template>
        <el-form-item>
          <el-button @click="onResetClick">重置</el-button>
          <el-button type="primary" @click="onSearchClick">搜索</el-button>
        </el-form-item>
        <div class="float-right">
          <el-button type="primary" @click="editeClick">批量编辑</el-button>
        </div>
      </el-form>
      <div class="new_tab_box">
        <div class="tab_item" :class="current == index?'cur':''" v-for="(item,index) in tabList" :key="index"
          @click="clickTabs(index)"><span>{{item.name}}</span>
          <div class="line" v-if="current == index"></div>
        </div>
      </div>
    </header>
    <div class="new_container" id='setHeightDom' :style="{height:height}">
      <BaseTable :data="tableData" :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}"
        tooltip-effect="dark" :column="current == 0?tableConfig : current == 1?tableConfig1:tableConfig2" pagination
        :auto-scroll="true" :total="totalPage" :page.sync="listQuery.current" @selection-change="selectionChange"
        :limit.sync="listQuery.size" @pagination="getList">
      </BaseTable>
      <el-dialog class="replay-dialog-img" :close-on-click-modal="false" title="编辑回复" center
        :visible.sync="dialogReply">
        <div class="dialog-con">
          <div class="words-box">
            <el-input class="words" type="textarea" placeholder="请输入文本" @input='handleWordsNum' v-model="textarea"
              maxlength="1000"></el-input>
            <div class="limit-box">
              <div class="cur" @click="addLink">添加一个超链接</div>
              <div>还可以输入{{wordsNum}}字，按下Enter健换行</div>
            </div>
          </div>
          <div class="dialog-btn">
            <el-button size="small" @click="resetText">重置</el-button>
            <el-button size="small" type="primary" @click="onSaveWord">确认</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 查看科室 -->
      <el-dialog class="depart-dialog-img" :class='showTeam?"show-team":""' :close-on-click-modal="false"
        :title="hospitalName" center :visible.sync="dialogDepart" @close='closeClick'>
        <div class="left-depart">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input class="search-input-replay" maxlength="20" clearable v-model="departObj.openDepartmentName"
                placeholder="请输入科室名称进行搜索" autocomplete="off">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="onResetClick('depart')">重置</el-button>
              <el-button type="primary" @click="onSearchClick('depart')">搜索</el-button>
            </el-form-item>
          </el-form>
          <BaseTable height='355px' :data="departData"
            :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}" tooltip-effect="dark"
            :column="tableConfig3" pagination :auto-scroll="true" :total="depaertTotalPage"
            :page.sync="departObj.current" @selection-change="selectionChange" :limit.sync="departObj.size"
            @pagination="getList('depart')">
          </BaseTable>
        </div>
        <!-- 查看团队 -->
        <div class="right-team" v-if="showTeam">
          <div class="team-name">{{team.hospitalName}} - {{team.openDepartmentName}}详情</div>
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input class="search-input-replay" clearable maxlength="20" v-model="teamObj.keyword"
                placeholder="请输入团队名称或姓名进行搜索" autocomplete="off">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="onResetClick('team')">重置</el-button>
              <el-button type="primary" @click="onSearchClick('team')">搜索</el-button>
            </el-form-item>
          </el-form>
          <BaseTable :data="teamData" height='355px'
            :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}" tooltip-effect="dark"
            :column="tableConfig4" pagination :auto-scroll="true" :total="teamTotalPage" :page.sync="teamObj.current"
            @selection-change="selectionChange" :limit.sync="teamObj.size" @pagination="getList('team')">
          </BaseTable>
        </div>
      </el-dialog>
      <!-- 批量回复 -->
      <el-dialog class="replay-dialog-img batch" :close-on-click-modal="false" title="批量回复配置" center
        :visible.sync="dialogBatch" width="720px" @close='closeBatch'>
        <el-form :inline="true" :model="batchQuery" size="small" label-width="105px" ref="batchForm" :rules="rules">
          <el-form-item label="码类型：" prop="qrcodeType">
            <el-select class="search-input-replay more-input" v-model="batchQuery.qrcodeType" @change="changeCode"
              placeholder="选择码类型">
              <el-option v-for="(item,index) in tabList" :key="index" :label="item.name" :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if='batchQuery.qrcodeType == 4' key='4'>
            <el-form-item label="选择机构：" prop='hospitalId'>
              <el-select class="search-input-replay more-input" maxlength="20" v-model="batchQuery.hospitalId"
                placeholder="请输入机构名称进行搜索" filterable remote reserve-keyword v-selectLoadmore="loadmoreHospital"
                :remote-method="remoteHospital" :loading="codeLoading" @change='onChangeHospital'
                @visible-change='closeHospital' clearable>
                <el-option v-for="(item,index) in hospitalList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择科室：">
              <el-cascader class="depart-cascader" clearable :disabled='!batchQuery.hospitalId' maxlength="20"
                placeholder="请输入科室进行搜索" :options="departList" :props="departProps" filterable @change='changeDepart'
                v-model="batchQuery.openDepartmentIdList">
              </el-cascader>
            </el-form-item>
            <el-form-item label="选择团队：">
              <el-select class="search-input-replay more-input" :disabled='batchQuery.openDepartmentIdList.length<1'
                maxlength="20" v-model="batchQuery.doctorTeamIdList" placeholder="请选择团队" clearable multiple filterable
                remote reserve-keyword v-selectLoadmore="loadmoreTeam" :remote-method="remoteTeamType"
                @change="changeTeam" :loading="codeLoading" @visible-change='closeTeam'>
                <el-option v-for="(item,index) in teamOptions" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择修改：">
              <el-radio-group :disabled="batchQuery.doctorTeamIdList.length>0" v-model="batchQuery.serviceQrCodeBelong">
                <el-radio label="2">当前码回复</el-radio>
                <el-radio label="1">全部</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-if='batchQuery.qrcodeType == 6' key='6'>
            <el-form-item label="病种码：" prop="diseaseTypeId">
              <el-select class="search-input-replay more-input" maxlength="20" v-model="batchQuery.diseaseTypeId"
                placeholder="请输入病种进行搜索" clearable filterable remote reserve-keyword
                v-selectLoadmore="loadmoreDiseaseType" :remote-method="remoteDiseaseType" :loading="codeLoading"
                @visible-change='closeDisease' @change='onChangeDisease'>
                <el-option v-for="(item,index) in diseaseTypeList" :key="index" :label="item.entryName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="码归属：" prop="diseaseQrCodeBelong">
              <el-radio-group v-model="batchQuery.diseaseQrCodeBelong" @change="changeCodeBelong">
                <el-radio label="1">全部</el-radio>
                <el-radio label="2">疗管团队</el-radio>
                <el-radio label="3">全部医生</el-radio>
                <el-radio label="4">部分医生</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择医生" v-if="batchQuery.diseaseQrCodeBelong == 4" prop="userIdList">
              <el-select class="search-input-replay more-input" multiple maxlength="20" v-model="batchQuery.userIdList"
                placeholder="请选择医生" clearable filterable remote reserve-keyword v-selectLoadmore="loadmoreDoctor"
                :remote-method="remoteDoctor" :loading="codeLoading" @visible-change='closeDoctor'>
                <el-option v-for="(item,index) in doctorList" :key="index" :label="item.doctorName"
                  :value="item.userId">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if='batchQuery.qrcodeType == 3' key='3'>
            <el-form-item label="选择拉C人：" prop="promoterQrCodeBelong">
              <el-radio-group v-model="batchQuery.promoterQrCodeBelong" @change="changeCodeBelong">
                <el-radio label="1">全部拉C人</el-radio>
                <el-radio label="2">部分拉C人</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="拉C人:" prop="promoterUserIdList" v-if="batchQuery.promoterQrCodeBelong == 2"
              key='promoterUserIdList'>
              <el-select class="search-input-replay more-input" maxlength="20" v-model="batchQuery.promoterUserIdList"
                placeholder="请搜索拉C人" clearable filterable multiple remote reserve-keyword
                v-selectLoadmore="loadmoreUser" :remote-method="remoteUser" :loading="codeLoading"
                @visible-change='closeUser'>
                <el-option v-for="(item,index) in userOptions" :key="index" :label="item.userName" :value="item.userId">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item style="margin-left:105px" v-if="batchQuery.qrcodeType">
            <div class="words-box batch-box">
              <el-input class="words" type="textarea" placeholder="请输入文本" @input='handleWordsNum' v-model="textarea"
                maxlength="1000"></el-input>
              <div class="limit-box">
                <div class="cur" @click="addLink">添加一个超链接</div>
                <div>还可以输入{{wordsNum}}字，按下Enter健换行</div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-btn">
          <el-button size="small" @click="resetBatch('batchForm')">重置</el-button>
          <el-button size="small" type="primary" @click="onConfirm('batchForm')">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { formateDate } from "../../commen/date.js";
import {
  delReply,
  getQrCodePublic,
  getDiseasetype,
  getHospital,
  updatePublicReply,
  getTeamByDepart,
  batchUpdatePublicReply,
  getDoctorByQrcode,
  getPromoterUser
} from "./api/index.js";
import { queryOpenDepartmentList } from "@/api/departmentManage.js";
export default {
  filters: {
    formateDate(time) {
      time = time * 1000;
      return formateDate(time);
    }
  },
  data() {
    return {
      dialogBatch: false,
      isDialog: false, //控制操作机构 列表机构 批量回复弹框中的机构
      batchQuery: {
        qrcodeType: null,
        hospitalId: "",
        openDepartmentIdList: [],
        doctorTeamIdList: [],
        serviceQrCodeBelong: "2", //选择修改 1-全部，2-当前码回复
        diseaseTypeIds: "", //病种,
        diseaseQrCodeBelong: "1", //选择码归属 1-全部，2-疗管团队，3-全部医生，4-部分医生
        promoterQrCodeBelong: "1", //1-全部，2-部分
        promoterUserIdList: [],
        userIdList: []
      },
      rules: {
        qrcodeType: [
          { required: true, message: "请选择码类型", trigger: "change" }
        ],
        hospitalId: [
          { required: true, message: "请选择机构", trigger: "change" }
        ],
        diseaseTypeId: [
          { required: true, message: "请选择病种", trigger: "change" }
        ],
        userIdList: [
          { required: true, message: "请选择医生", trigger: "change" }
        ],
        diseaseQrCodeBelong: [
          { required: true, message: "请选择码归属", trigger: "change" }
        ],
        promoterQrCodeBelong: [
          { required: true, message: "请选择拉C人", trigger: "change" }
        ],
        promoterUserIdList: [
          { required: true, message: "请选择拉C人", trigger: "change" }
        ]
      },
      departList: [],
      departProps: {
        value: "id",
        label: "name",
        multiple: true
      },
      teamOptions: [],
      userOptions: [],
      flagType: false,
      current: 0,
      dialogReply: false,
      textarea: "",
      scenario: "",
      wordsNum: 1000,
      showTeam: false,
      dialogDepart: false,
      tabList: [
        { name: "服务码", val: 0, type: 4 },
        { name: "病种码", val: 1, type: 6 },
        { name: "拉C码", val: 2, type: 3 }
      ],
      ruleForm: {
        replyType: ""
      },
      height: "500px",
      codeLoading: false,
      diseaseTypePages: 1,
      teamPages: 1,
      doctorPages: 1,
      diseaseObj: {
        current: 1,
        size: 20,
        keyword: "",
        strategic: 1
      },
      diseaseTypeList: [],
      hospitalPages: 0,
      hospitalObj: {
        current: 1,
        size: 20,
        companyId: localStorage.getItem("companyId"),
        name: ""
      },
      teamObjByDepart: {
        current: 1,
        size: 20,
        openDepartmentIdList: [],
        keyword: ""
      },
      hospitalList: [],
      tableData: [],
      totalPage: "",
      listQuery: {
        current: 1,
        size: 10,
        keyword: "",
        userName: "",
        hospitalId: "",
        diseaseTypeId: ""
      },
      qrcodeType: 4, //二维码类型 1-团队，2-临时，3-拉c，4-医院（服务），5科室 6-病种 7-疗管病种）
      departData: [],
      departObj: {
        current: 1,
        size: 10,
        openDepartmentName: "",
        hospitalId: "",
        qrcodeType: 5 //二维码类型 1-团队，2-临时，3-拉c，4-医院（服务），5科室 6-病种 7-疗管病种）
      },
      doctorObj: {
        current: 1,
        size: 10,
        doctorName: "",
        diseaseTypeIds: []
      },
      doctorList: [],
      depaertTotalPage: 0,
      teamData: [],
      teamObj: {
        current: 1,
        size: 10,
        openDepartmentId: "",
        hospitalId: "",
        qrcodeType: 1,
        keyword: ""
      },
      userObj: {
        current: 1,
        size: 10,
        userName: ""
      },
      teamTotalPage: 0,
      hospitalName: "",
      team: {
        hospitalName: "",
        openDepartmentName: ""
      },
      //服务码
      tableConfig: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          type: "index"
        },
        {
          label: "机构名称",
          align: "center",
          prop: "hospitalName",
          size: "mini"
        },
        {
          label: "互医机构名称",
          align: "center",
          prop: "platformName",
          size: "mini"
        },
        {
          label: "机构服务类型",
          align: "center",
          prop: "orgServerTypeName",
          size: "mini"
        },
        {
          label: "医院等级",
          align: "center",
          prop: "gradeName",
          size: "mini"
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 1);
                    }
                  }
                },
                "编辑回复"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 2, "depart");
                    }
                  }
                },
                "查看科室"
              )
            ]);
          }
        }
      ],
      //病种码
      tableConfig1: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          type: "index"
        },
        {
          label: "病种",
          align: "center",
          prop: "diseaseTypeName",
          size: "mini"
        },
        {
          label: "码归属",
          align: "center",
          prop: "selfName",
          size: "mini"
        },
        {
          label: "互医机构名称",
          align: "center",
          prop: "platformName",
          size: "mini"
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 1);
                    }
                  }
                },
                "编辑回复"
              )
            ]);
          }
        }
      ],
      //拉c码
      tableConfig2: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          type: "index"
        },
        {
          label: "用户",
          align: "center",
          prop: "userName",
          size: "mini"
        },
        {
          label: "手机号",
          align: "center",
          prop: "phone",
          size: "mini"
        },
        {
          label: "机构名称",
          align: "center",
          prop: "hospitalName",
          size: "mini"
        },
        {
          label: "码类型",
          align: "center",
          prop: "isTempQrcode",
          size: "mini",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.isTempQrcode == 1 ? "临时" : "永久"}
              </span>
            );
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 1);
                    }
                  }
                },
                "编辑回复"
              )
            ]);
          }
        }
      ],
      tableConfig3: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          width: 60,
          type: "index"
        },
        {
          label: "线下科室",
          align: "center",
          prop: "openDepartmentName",
          size: "mini"
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 1, "depart");
                    }
                  }
                },
                "编辑回复"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 3);
                    }
                  }
                },
                "查看团队"
              )
            ]);
          }
        }
      ],
      tableConfig4: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          width: 60,
          type: "index"
        },
        {
          label: "团队名称",
          align: "center",
          prop: "doctorTeamName",
          size: "mini"
        },
        {
          label: "医生",
          align: "center",
          prop: "doctorName",
          size: "mini"
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope.row, 1, "team");
                    }
                  }
                },
                "编辑回复"
              )
            ]);
          }
        }
      ]
    };
  },
  sockets: {},
  directives: {
    selectLoadmore: {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  mounted() {
    this.height = this.handleHeight() + "px";
    this.getList();
  },
  methods: {
    changeCode(val) {
      this.resetText();
    },
    changeCodeBelong(val) {
      // if (val == 4) {
      //   this.getDoctorByQrcode();
      // }
    },
    changeDepart(list) {
      let end = [];
      this.batchQuery.doctorTeamIdList = [];
      list.map(item => {
        if (item.length > 1) {
          end = end.concat(item.slice(1));
        } else {
          end = end.concat(item);
        }
      });
      this.teamObjByDepart.openDepartmentIdList = end;
    },
    changeTeam(val) {
      if (val) {
        this.batchQuery.serviceQrCodeBelong = "1";
      }
    },
    editeClick() {
      this.isDialog = true;
      this.hospitalObj = this.$options.data().hospitalObj;
      this.batchQuery = this.$options.data().batchQuery;
      this.dialogBatch = true;
      this.resetText();
    },
    closeBatch() {
      this.isDialog = false;
      this.resetText();
      this.$refs.batchForm.resetFields();
    },
    getList(val) {
      let params = this.listQuery;
      params.qrcodeType = this.qrcodeType;
      if (val == "depart") {
        params = this.departObj;
      } else if (val == "team") {
        params = this.teamObj;
      }
      getQrCodePublic(params).then(res => {
        if (res.code == 0) {
          let end = [];
          if (res.data && res.data.records.length) {
            end = res.data.records;
            end.map(item => {
              item.gradeName = item.levelName + item.gradeName;
              item.selfName =
                item.qrcodeType == 6 ? item.doctorName : item.doctorTeamName;
            });
          }
          if (val == "depart") {
            this.departData = end;
            this.depaertTotalPage = res.data.total;
          } else if (val == "team") {
            this.teamData = end;
            this.teamTotalPage = res.data.total;
          } else {
            this.tableData = end;
            this.totalPage = res.data.total;
          }
        }
      });
    },
    clickTabs(index) {
      this.tableData = [];
      this.listQuery = this.$options.data().listQuery;
      this.current = index;
      //二维码类型 1-团队，2-临时，3-拉c，4-医院(服务码)，5科室 6-病种 7-疗管病种）
      if (index == 0) {
        this.qrcodeType = 4;
      } else if (index == 1) {
        this.qrcodeType = 6;
      } else {
        this.qrcodeType = 3;
      }
      this.listQuery.current = 1;
      this.hospitalList = [];
      this.diseaseTypeList = [];
      this.getList();
    },
    //操作
    hometHandel(row, type, flag) {
      if (type == 1) {
        this.scenario = row.scenario;
        this.textarea = row.characters;
        this.handleWordsNum();
        this.dialogReply = true;
      } else if (type == 2) {
        this.departObj.hospitalId = row.hospitalId;
        this.dialogDepart = true;
        this.hospitalName = row.hospitalName;
        this.getList("depart");
      } else if (type == 3) {
        this.showTeam = true;
        this.teamObj.openDepartmentId = row.openDepartmentId;
        this.teamObj.hospitalId = row.hospitalId;
        this.teamData = [];
        this.team.openDepartmentName = row.openDepartmentName;
        this.team.hospitalName = row.hospitalName;
        this.getList("team");
      }
      if (flag) {
        this.flagType = flag;
      } else {
        this.flagType = false;
      }
    },
    closeClick() {
      this.departObj = this.$options.data().departObj;
      this.teamObj = this.$options.data().teamObj;
      this.showTeam = false;
    },
    onResetClick(val) {
      if (val == "depart") {
        this.departObj.openDepartmentName = "";
        this.departObj.current = 1;
      } else if (val == "team") {
        this.teamObj.current = 1;
        this.teamObj.keyword = "";
      } else {
        this.listQuery = this.$options.data().listQuery;
        this.hospitalList = [];
        this.diseaseTypeList = [];
      }
    },
    onSearchClick(val) {
      if (val == "depart") {
        this.departObj.current = 1;
      } else if (val == "team") {
        this.teamObj.current = 1;
      } else {
        this.listQuery.current = 1;
      }
      this.getList(val);
    },

    //搜索机构
    remoteHospital(query) {
      this.hospitalObj.name = query;
      this.hospitalObj.current = 1;
      this.getHospital(true);
    },
    closeHospital(val) {
      //下拉框出现隐藏时
      if (!val) {
        this.hospitalObj.name = "";
      } else {
        this.getHospital(true);
      }
    },
    closeDisease(val) {
      if (!val) {
        this.diseaseObj.keyword = "";
      } else {
        this.getDiseaseTypeList(true);
      }
      // if (!this.listQuery.diseaseTypeId) {
      //   this.diseaseTypeList = [];
      // }
    },
    closeDoctor(val) {
      if (!val) {
        this.doctorObj.doctorName = "";
      } else {
        this.getDoctorByQrcode(true);
      }
    },
    closeTeam(val) {
      if (!val) {
        this.teamObjByDepart.keyword = "";
      } else {
        if (this.teamObjByDepart.openDepartmentIdList.length > 0) {
          this.getTeamList(true);
        }
      }
    },
    closeUser(val) {
      if (!val) {
        this.userObj.userName = "";
      } else {
        this.getUserList(true);
      }
    },
    //获取机构
    getHospital(key) {
      let params = this.hospitalObj;
      if (key) {
        this.hospitalObj.current = 1;
        this.hospitalList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        getHospital(params).then(res => {
          this.codeLoading = false;
          this.hospitalPages = res.data.pages;
          this.hospitalList = this.hospitalList.concat(res.data.records);
        });
      }, 200);
    },
    //获取医生
    getDoctorByQrcode(key) {
      let params = this.doctorObj;
      params.qrcodeType = this.batchQuery.qrcodeType;
      if (key) {
        this.doctorList = [];
        this.codeLoading = true;
        this.doctorObj.current = 1;
      }
      setTimeout(() => {
        getDoctorByQrcode(params).then(res => {
          this.codeLoading = false;
          this.doctorPages = res.data.pages;
          this.doctorList = this.doctorList.concat(res.data.records);
        });
      }, 200);
    },
    //获取团队
    getTeamList(key) {
      let params = this.teamObjByDepart;
      if (key) {
        this.teamOptions = [];
        this.codeLoading = true;
        this.teamObjByDepart.current = 1;
      }
      setTimeout(() => {
        getTeamByDepart(params).then(res => {
          this.codeLoading = false;
          this.teamPages = res.data.pages;
          this.teamOptions = this.teamOptions.concat(res.data.records);
        });
      }, 200);
    },
    //获取拉C人
    getUserList(key) {
      let params = this.userObj;
      if (key) {
        this.userObj.current = 1;
        this.userOptions = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        getPromoterUser(params).then(res => {
          this.codeLoading = false;
          this.userPages = res.data.pages;
          this.userOptions = this.userOptions.concat(res.data.records);
        });
      }, 200);
    },
    //获取科室
    getDepart() {
      let params = {
        hospitalId: this.batchQuery.hospitalId
      };
      queryOpenDepartmentList(params).then(res => {
        this.departList = res.data;
      });
    },

    loadmoreHospital() {
      this.hospitalObj.current++;
      if (this.hospitalObj.current > this.hospitalPages) {
        return;
      }
      this.getHospital();
    },
    onChangeHospital(id) {
      if (this.isDialog) {
        this.batchQuery.hospitalId = id;
        this.departObj.companyId = id;
        this.batchQuery.openDepartmentIdList = [];
        this.batchQuery.doctorTeamIdList = [];
        if (id) {
          this.getDepart();
        }
      } else {
        this.listQuery.hospitalId = id;
      }
    },
    //搜索病种
    remoteDiseaseType(query) {
      this.diseaseObj.keyword = query;
      this.diseaseObj.current = 1;
      this.getDiseaseTypeList(true);
    },
    //搜索团队
    remoteTeamType(name) {
      this.teamObjByDepart.keyword = name;
      this.getTeamList(true);
    },
    //搜索医生
    remoteDoctor(name) {
      this.doctorObj.doctorName = name;
      this.getDoctorByQrcode(true);
    },
    //搜索拉C人
    remoteUser(name) {
      this.userObj.userName = name;
      this.getUserList(true);
    },
    //获取病种
    getDiseaseTypeList(key) {
      let params = this.diseaseObj;
      if (key) {
        this.diseaseObj.current = 1;
        this.diseaseTypeList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        getDiseasetype(params).then(res => {
          this.codeLoading = false;
          this.diseaseTypePages = res.data.pages;
          this.diseaseTypeList = this.diseaseTypeList.concat(res.data.records);
        });
      }, 200);
    },
    //下拉病种
    loadmoreDiseaseType() {
      this.diseaseObj.current++;
      if (this.diseaseObj.current > this.diseaseTypePages) {
        return;
      }
      this.getDiseaseTypeList();
    },
    // 下拉团队
    loadmoreTeam() {
      this.teamObjByDepart.current++;
      if (this.teamObjByDepart.current > this.teamPages) {
        return;
      }
      this.getTeamList();
    },
    //下拉医生
    loadmoreDoctor() {
      this.doctorObj.current++;
      if (this.doctorObj.current > this.doctorPages) {
        return;
      }
      this.getDoctorByQrcode();
    },
    // 下拉C人
    loadmoreUser() {
      this.userObj.current++;
      if (this.userObj.current > this.userPages) {
        return;
      }
      this.getUserList();
    },
    onChangeDisease(id) {
      if (this.isDialog) {
        this.doctorObj.diseaseTypeIds = [id];
        //修改病种，清空之前医生
        if (this.batchQuery.diseaseQrCodeBelong == 4) {
          this.batchQuery.userIdList = [];
        }
      } else {
        this.listQuery.diseaseTypeId = id;
      }
    },
    resetText() {
      this.textarea = "";
      this.wordsNum = 1000;
    },
    resetBatch(formName) {
      this.$refs[formName].resetFields();
      this.batchQuery.openDepartmentIdList = [];
      this.batchQuery.doctorTeamIdList = [];
    },
    onConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.textarea.trim().replace(/[\r\n]/g, "").length < 1) {
            this.$message.error("请输入文本！");
          } else {
            let obj = this.batchQuery;
            let params = {
              qrcodeType: obj.qrcodeType,
              characters: this.textarea
            };
            if (this.batchQuery.qrcodeType == 4) {
              params.hospitalId = obj.hospitalId;
              params.openDepartmentIdList = this.teamObjByDepart.openDepartmentIdList;
              params.serviceQrCodeBelong = obj.serviceQrCodeBelong;
              params.doctorTeamIdList = obj.doctorTeamIdList;
            } else if (this.batchQuery.qrcodeType == 6) {
              params.diseaseQrCodeBelong = obj.diseaseQrCodeBelong;
              params.userIdList = obj.userIdList;
              params.diseaseTypeIds = [obj.diseaseTypeId];
            } else {
              params.promoterQrCodeBelong = obj.promoterQrCodeBelong;
              params.promoterUserIdList = obj.promoterUserIdList;
            }
            // debugger
            batchUpdatePublicReply(params).then(res => {
              this.dialogBatch = false;
              this.$message.success("操作成功！");
              this.clickTabs(0);
            });
          }
        } else {
          console.log(this.batchQuery);
          return false;
        }
      });
    },
    onSaveWord() {
      if (this.textarea.trim().replace(/[\r\n]/g, "").length < 1) {
        this.$message.error("请输入文本！");
      } else {
        let params = {
          characters: this.textarea,
          scenario: this.scenario
        };
        updatePublicReply(params).then(res => {
          this.$message.success("保存成功");
          if (this.flagType) {
            this.getList(this.flagType);
          } else {
            this.getList();
          }
          this.dialogReply = false;
        });
      }
    },
    handleWordsNum() {
      if (this.textarea) {
        this.wordsNum = 1000 - this.textarea.length;
      } else {
        this.wordsNum = 1000;
      }
    },
    addLink() {
      let str = '<a href="你要放入的链接">起个名字</a>';
      if (1000 - this.textarea.length >= str.length) {
        this.textarea = this.textarea + str;
      }
      this.handleWordsNum();
    },
    delReplyClick() {
      if (this.id) {
        this.delReply(this.id);
      } else {
        this.clearData();
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    delReply(id, flag) {
      delReply(id)
        .then(res => {
          if (res.code == 0) {
            this.$message.success("删除成功！");
            if (flag) {
              this.listQuery.current = 1;
              this.init();
            } else {
              //收到回复删除
              this.getDetailsByTypeData();
            }
          }
        })
        .catch(error => {
          this.$message.error(`${error.message}`);
        });
    },

    addReplyClick() {
      this.$router.push({
        path: "/addreply",
        query: {
          publicId: this.publicId
        }
      });
    },
    selectionChange() {}
  },
  destroyed() {
    clearInterval(this.timerUser);
  }
};
</script>
<style lang="less" >
.el-message-box.del-dialog {
  /deep/.el-message-box__message p {
    color: #000;
  }
}
.depart-cascader .el-input {
  width: 500px;
}
.depart-cascader .el-cascader__tags,
.search-input-replay .el-select__tags {
  max-height: 100px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.depart-cascader .el-cascader__tags::-webkit-scrollbar,
.search-input-replay .el-select__tags::-webkit-scrollbar {
  width: 2px;
  height: 10px;
}
.depart-cascader .el-cascader__tags::-webkit-scrollbar-thumb,
.search-input-replay .el-select__tags::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #f0f2f5;
}
</style>
<style lang="less" scoped>
.float-right {
  float: right;
}
.search-input-replay {
  width: 330px;
  // height: 34px;
}
.search-input-replay.more-input {
  width: 500px;
}
.replay-dialog-img {
  /deep/.el-dialog {
    width: 880px;
    height: 610px;
    border-radius: 2px;
  }
}
.batch {
  /deep/.el-dialog {
    height: auto;
    // max-height: 826px;
  }
}

.depart-dialog-img {
  /deep/.el-dialog {
    height: 610px;
    border-radius: 2px;
  }
}
.show-team {
  /deep/.el-dialog {
    width: 1180px;
    .el-dialog__header {
      text-align: left;
    }
  }
  .left-depart {
    width: 550px;
  }
  /deep/.el-dialog__headerbtn {
    z-index: 66;
  }
}
.team-name {
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85);
}
.right-team {
  width: 590px;
  height: 610px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 40px 20px 10px;
  .el-form {
    text-align: left;
    margin-top: 25px;
  }
}
.dialog-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 65px;
}

.words-box {
  width: 820px;
  height: 380px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  padding: 25px 32px;
  overflow: hidden;
}
.batch-box {
  width: 500px;
  height: 318px;
  background: #ffffff;
  border-radius: 10px;
}
.words.el-textarea {
  padding: 0;
  height: 290px;
  margin-bottom: 20px;
  /deep/.el-textarea__inner {
    height: 100%;
    border: none;
    resize: none;
    padding: 0;
  }
}
.batch-box .words.el-textarea {
  height: 240px;
}
.limit-box {
  display: flex;
  justify-content: space-between;
  color: #333;
  line-height: 17px;
  font-weight: bold;
  .cur {
    color: #1a7bfc;
    cursor: pointer;
  }
}
.dialog-btn {
  margin-top: 42px;
  /deep/.el-button {
    width: 68px;
    margin-right: 30px;
  }
}
.batch .dialog-btn {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 25px;
}
.new_tab_box {
  overflow: hidden;
  .tab_item {
    float: left;
    margin-right: 26px;
    font-size: 14px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;
    cursor: pointer;
  }
  .cur {
    color: #1a7bfc;
  }
  .line {
    width: 28px;
    height: 2px;
    margin-top: 12px;
    background: #1a7bfc;
  }
}
.new_container {
  margin: 22px 16px;
  padding: 20px 25px;
  background: #fff;
  overflow: auto;
}
</style>
